import React from 'react';

import Login from '../Login';
import Footer from '../Footer';

function LoginPage() {
  return (
    <div>
      <Login />
      <Footer />
    </div>
  );
}

export default LoginPage;
